module.exports = __webpack_public_path__ + "media/public/img/landing_page/wt-what-is-magpie-e15319ba72908bfa09a3a9939e5f2717.png";